import React from 'react';
import { ActionIcon, CloseIcon, Divider } from '@inexture/core';
import { closeAllModals } from '@inexture/modals';

const RegisterHeader: React.FC = () => (
  <>
    <div className="absolute top-1 right-1">
      <ActionIcon onClick={() => closeAllModals()} variant="subtle">
        <CloseIcon />
      </ActionIcon>
    </div>
    <div className="p-5 text-center">
      <h3 className="text-[25px] text-[#7d94a5]">PROBEER</h3>
      <p className="text-[12px] text-[#5a6b78]">
        30 dagen GRATIS en volledig VRIJBLIJVEND.
      </p>
    </div>
    <Divider />
  </>
);

export default RegisterHeader;
